import { AnyAction, isType } from 'typescript-fsa';
import { actionLogClear } from './actions';

export interface ActionLogState {
    actionCount: { [type: string]: number };
}

const initialActionLogState: ActionLogState = {
    actionCount: {}
};

export function actionLogReducer(state: ActionLogState = initialActionLogState, action: AnyAction): ActionLogState {
    if (isType(action, actionLogClear)) {
        state = { ...state, actionCount: { ...state.actionCount, [action.payload]: 0 } };
    }
    const newValue = (state.actionCount[action.type] ? state.actionCount[action.type] : 0) + 1;
    return { ...state, actionCount: { ...state.actionCount, [action.type]: newValue } };

}
